import VictoryPie from "./components/victory-pie";
export { VictoryPie };